/* 
 * File: src/client/updateNotification/useUpdateNotification.jsx
 * Descrizione: Custom hook per gestire lo stato della notifica di aggiornamento.
 * Ascolta l'evento "swUpdate" e fornisce la funzione per aggiornare l'app.
 */

import { useState, useEffect } from 'react';

export default function useUpdateNotification() {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    const handleSWUpdate = () => {
      setUpdateAvailable(true);
    };

    window.addEventListener('swUpdate', handleSWUpdate);
    return () => {
      window.removeEventListener('swUpdate', handleSWUpdate);
    };
  }, []);

  // Funzione per forzare il reload della pagina (applica l'aggiornamento)
  const handleUpdate = () => {
    window.location.reload();
  };

  return { updateAvailable, handleUpdate };
}
